import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BankEntry;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import differenceWith from 'lodash/differenceWith';
import intersectionWith from 'lodash/intersectionWith';
import isEqual from 'lodash/isEqual';
import isUndefined from 'lodash/isUndefined';
import keyBy from 'lodash/keyBy';
import { Alert } from '@instructure/ui-alerts';
import { BreadcrumbLink } from '@instructure/ui-breadcrumb';
import { IconButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { IconDiscussionLine, IconDiscussionSolid } from '@instructure/ui-icons';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { HeaderBreadCrumb } from '../HeaderBreadCrumb';
import EntrySave from '../../../common/components/resources/entry/EntrySave';
import ItemEdit from '../../../common/components/resources/item/ItemEdit';
import ItemFeedbackModal from '../../../building/components/resources/ItemFeedbackModal';
import ItemShow from '../../../common/components/resources/item/ItemShow';
import Page from '../../../common/components/layout/Page';
import Spinner from '../../../common/components/shared/spinner/Spinner';
import StimulusEditInfo from '../../../common/components/resources/stimulus/StimulusEditInfo';
import StimulusShowInfo from '../../../common/components/resources/stimulus/StimulusShowInfo';
import TagSuggestSelect from '../../../common/components/shared/TagSuggestSelect';
import WarningWrapper from '../../../common/components/resources/WarningWrapper';
import t from '@instructure/quiz-i18n/es/format-message';
import { createItem } from '../../../building/api/items';
import { createStimulus } from '../../../building/api/stimuli';
import { propsForItemVersioningWrapper, propsForStimulusVersioningWrapper } from '../../../common/util/warningHelpers';
import NavWrapper from '../NavWrapper';
import { API_INPUT_VALIDATION_ERROR, CLEAR_ALL_INPUT_VALIDATION_ERRORS, ITEM_FEEDBACK_MODAL, ITEM_FEEDBACK_MODAL_ITEM, ITEM_FEEDBACK_MODAL_FEEDBACK, PARENT_TYPE_BANK, TextInput, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var BankEntry = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BankEntry = /*#__PURE__*/function (_Component) {
  function BankEntry() {
    var _this;
    _classCallCheck(this, BankEntry);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BankEntry, [].concat(args));
    _defineProperty(_this, "state", {
      validationErrorsFromApi: {}
    });
    _defineProperty(_this, "setNavToBankRef", function (node) {
      _this.navToBankRef = node;
    });
    _defineProperty(_this, "navigateToBank", function () {
      _this.props.navigateToBank(_this.props.bankId);
    });
    _defineProperty(_this, "handleTitleChange", function (e) {
      _this.props.changeItemTitle(_this.props.entry.id, e.target.value);
    });
    _defineProperty(_this, "clearValidationErrorsFromApi", function (inputId) {
      if (inputId === CLEAR_ALL_INPUT_VALIDATION_ERRORS) {
        _this.setState({
          validationErrorsFromApi: {}
        });
      }
      if (_this.state.validationErrorsFromApi[inputId]) {
        var newErrors = Object.assign({}, _this.state.validationErrorsFromApi);
        delete newErrors[inputId];
        _this.setState({
          validationErrorsFromApi: newErrors
        });
      }
    });
    _defineProperty(_this, "submitHandler", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!_this.props.entry.isTemporary()) {
              _context.next = 6;
              break;
            }
            _context.next = 4;
            return _this.temporarySubmit();
          case 4:
            _context.next = 8;
            break;
          case 6:
            _context.next = 8;
            return _this.normalSubmit();
          case 8:
            _context.next = 16;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            if (!_context.t0.validationErrorsFromApi) {
              _context.next = 15;
              break;
            }
            _this.setState({
              validationErrorsFromApi: _context.t0.validationErrorsFromApi
            });
            // Throwing an error here would cause an alert banner to show,
            // which we don't want in the case of a simple input validation error
            return _context.abrupt("return", API_INPUT_VALIDATION_ERROR);
          case 15:
            throw _context.t0;
          case 16:
            _this.navigateToBank();
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    })));
    _defineProperty(_this, "handleRef", function (node) {
      _this.itemEditArea = node;
    });
    _defineProperty(_this, "clearChanges", function () {
      _this.clearValidationErrorsFromApi(CLEAR_ALL_INPUT_VALIDATION_ERRORS);
      if (!_this.props.entry) return;
      if (_this.props.entry.isTemporary()) {
        _this.props.clearTemporaryBankItem(_this.props.bankId);
      }
      _this.props.clearModifications('items', _this.props.entry.id);
      _this.props.setPendingDeletionTagAssociations(_this.props.bankEntry.entryType, _this.props.entry.id, []);
      _this.props.setPendingAdditionTagAssociations(_this.props.bankEntry.entryType, _this.props.entry.id, []);
    });
    _defineProperty(_this, "handlePointsChange", function (points) {
      _this.props.changeQuizEntryPoints(_this.props.entry.id, points);
    });
    _defineProperty(_this, "editProps", function (entry) {
      return {
        cancelHandler: _this.navigateToBank,
        clearChanges: _this.clearChanges,
        clearValidationErrorsFromApi: _this.clearValidationErrorsFromApi,
        contextUuid: null,
        entry: entry,
        guid: "".concat(_this.props.bankEntry.id, "_bank_entry_edit"),
        handleQuizEntryPointsChange: _this.handlePointsChange,
        itemEditArea: _this.itemEditArea,
        parentId: _this.props.bankId,
        parentType: PARENT_TYPE_BANK,
        stimulus: entry,
        submitHandler: _this.submitHandler,
        validationErrorsFromApi: _this.state.validationErrorsFromApi,
        scope: _this.props.scope
      };
    });
    _defineProperty(_this, "openFeedbackModal", function () {
      _this.props.setUi(ITEM_FEEDBACK_MODAL_ITEM, _this.props.entry.getWorkingInstance());
      _this.props.setUi(ITEM_FEEDBACK_MODAL_FEEDBACK, _this.props.entry.getWorkingInstance().feedback);
      _this.props.openModal(ITEM_FEEDBACK_MODAL, {
        modalTrigger: _this.addFeedbackButton
      });
    });
    _defineProperty(_this, "storeFeedbackButtonRef", function (button) {
      _this.addFeedbackButton = button;
    });
    _defineProperty(_this, "compareTagValues", function (left, right) {
      return left.tag_value === right.tag_value;
    });
    _defineProperty(_this, "tagToAssociation", function (_ref2) {
      var value = _ref2.value;
      return {
        tag_value: value
      };
    });
    _defineProperty(_this, "handleTagChange", function (tags) {
      var bankEntry = _this.props.bankEntry;
      var tagAssociations = _this.props.tagAssociations.toJS();
      var associations = tags.map(_this.tagToAssociation);
      var removed = differenceWith(tagAssociations, associations, _this.compareTagValues);
      var created = differenceWith(associations, tagAssociations, _this.compareTagValues);
      // If a tag that was removed is being re-added,
      // remove from both addAssociations and deletedTags
      var restored = intersectionWith(created, removed, _this.compareTagValues);
      var addOperations = differenceWith(created, restored, isEqual);
      var deleteOperations = differenceWith(removed, restored, _this.compareTagValues);
      var bankEntryId = _this.getBankEntryId(bankEntry);
      _this.props.setPendingDeletionTagAssociations(bankEntry.entryType, bankEntryId, deleteOperations);
      _this.props.setPendingAdditionTagAssociations(bankEntry.entryType, bankEntryId, addOperations);
    });
    return _this;
  }
  _inherits(BankEntry, _Component);
  return _createClass(BankEntry, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isTemporary()) {
        this.props.getBankEntry(this.props.bankId, this.props.bankEntryId);
      }
      if (this.navToBankRef) {
        ReactDOM.findDOMNode(this.navToBankRef).focus();
      }
      this.props.getBank(this.props.bankId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.setShouldClone(false);
    }
  }, {
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.setShouldClone(false);
    }
  }, {
    key: "isTemporary",
    value: function isTemporary() {
      return this.props.entry && this.props.entry.isTemporary();
    }
  }, {
    key: "isItemEntry",
    value: function isItemEntry() {
      return this.props.bankEntry.entryType === 'Item';
    }
  }, {
    key: "entryLinkName",
    value: function entryLinkName() {
      if (this.isTemporary()) {
        return this.isItemEntry() ? t('New Question') : t('New Stimulus');
      } else {
        return this.isItemEntry() ? t('Edit Question') : t('Edit Stimulus');
      }
    }
  }, {
    key: "renderBankBreadCrumbLink",
    value: function renderBankBreadCrumbLink() {
      return jsx(BreadcrumbLink, {
        key: "bank",
        onClick: this.navigateToBank,
        ref: this.setNavToBankRef
      }, this.props.bank.title);
    }
  }, {
    key: "renderBankEntryBreadCrumbLink",
    value: function renderBankEntryBreadCrumbLink() {
      return jsx(BreadcrumbLink, {
        key: "bankEntry"
      }, this.entryLinkName());
    }
  }, {
    key: "renderNav",
    value: function renderNav() {
      var _this$props = this.props,
        scope = _this$props.scope,
        closeTray = _this$props.closeTray,
        navigateToBanks = _this$props.navigateToBanks,
        navigateToBuild = _this$props.navigateToBuild,
        returnToUrl = _this$props.returnToUrl;
      var isScopeEmpty = !Object.keys(scope).length;
      return jsx(NavWrapper, {
        closeTray: closeTray,
        navigateToBanks: navigateToBanks,
        navigateToBuild: navigateToBuild,
        returnToUrl: isScopeEmpty ? null : returnToUrl,
        scope: scope,
        isCompact: this.props.isCompact,
        iceTopNavBarEnabled: this.props.iceTopNavBarEnabled,
        menuItemPath: "/banks/".concat(this.props.bankId, "/bank_entries/").concat(this.props.bankEntryId || 'new')
      }, this.renderBankBreadCrumbLink(), this.renderBankEntryBreadCrumbLink());
    }
  }, {
    key: "renderTitle",
    value: function renderTitle(entry) {
      if (this.isItemEntry()) {
        return jsx(TextInput, {
          renderLabel: jsx(ScreenReaderContent, null, t('Edit question title')),
          type: "text",
          placeholder: t('Question Title'),
          onChange: this.handleTitleChange,
          value: entry.getWorkingInstance().title || ''
        });
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(entry) {
      if (!entry) return;
      var props = this.editProps(entry);
      var identifier = this.isItemEntry() ? t('Question { id }', {
        id: entry.id
      }) : t('Stimulus { id }', {
        id: entry.id
      });
      var tempIdentifier = this.isItemEntry() ? t('New Question') : t('New Stimulus');
      var itemIdentifier = this.isTemporary() ? tempIdentifier : identifier;
      var entryName = this.isItemEntry() ? entry.getInteractionType().name : t('Stimulus');
      var separator = ' | ';
      return jsx("div", {
        css: this.props.styles.header
      }, jsx("div", {
        css: this.props.styles.leftHeader
      }, jsx("div", {
        css: this.props.styles.headerText
      }, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, entryName, jsx(PresentationContent, null, separator), itemIdentifier))), this.renderTitle(entry), jsx("div", {
        css: this.props.styles.rightHeader
      }, jsx(EntrySave, props)));
    }
  }, {
    key: "hasPendingTagModifications",
    value: function hasPendingTagModifications() {
      return !this.props.pendingDeletionTags.isEmpty() || !this.props.pendingAdditionTags.isEmpty();
    }
  }, {
    key: "createTagsForClone",
    value: function createTagsForClone(newBankEntry, tags) {
      this.props.createTagAssociations(newBankEntry.id, newBankEntry.entry_type, newBankEntry.entry.id, tags.map(function (tag) {
        return tag.tag_value;
      }));
      // Pending tag associations were applied to the original bank entry, so clear those out
      this.props.setPendingAdditionTagAssociations(this.props.bankEntry.entryType, this.props.entry.id, []);
      this.props.setPendingDeletionTagAssociations(this.props.bankEntry.entryType, this.props.entry.id, []);
    }
  }, {
    key: "updateTagsForEntry",
    value: function () {
      var _updateTagsForEntry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.props.shouldClone) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return this.props.createTagAssociations(this.props.bankEntryId, this.props.bankEntry.entryType, this.getBankEntryId(this.props.bankEntry), this.props.pendingAdditionTags.map(function (tagToAdd) {
                return tagToAdd.get('tag_value');
              }));
            case 3:
              _context2.next = 5;
              return this.props.deleteTagAssociations(this.props.bankEntryId, this.props.bankEntry.entryType, this.getBankEntryId(this.props.bankEntry), this.props.pendingDeletionTags.map(function (tagToDelete) {
                return tagToDelete.get('id');
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateTagsForEntry() {
        return _updateTagsForEntry.apply(this, arguments);
      }
      return updateTagsForEntry;
    }()
  }, {
    key: "normalSubmit",
    value: function () {
      var _normalSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var entry, tags, createEntryCb, newBankEntry, workingEntry, updateFunc, toClear;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              entry = this.props.entry;
              if (!(entry.hasModifications() || this.props.shouldClone && this.hasPendingTagModifications())) {
                _context3.next = 17;
                break;
              }
              if (!this.props.shouldClone) {
                _context3.next = 11;
                break;
              }
              tags = this.visibleTagAssociations();
              createEntryCb = this.isItemEntry() ? createItem : createStimulus;
              _context3.next = 7;
              return this.props.cloneBankEntry(this.props.bankEntry, createEntryCb);
            case 7:
              newBankEntry = _context3.sent;
              this.createTagsForClone(newBankEntry, tags);
              _context3.next = 15;
              break;
            case 11:
              workingEntry = entry.getWorkingInstance();
              updateFunc = this.isItemEntry() ? this.props.updateItem : this.props.updateStimulus;
              _context3.next = 15;
              return updateFunc(workingEntry, this.props.bankId, 'bank');
            case 15:
              toClear = this.isItemEntry() ? 'items' : 'stimuli';
              this.props.clearModifications(toClear, entry.id);
            case 17:
              if (!this.hasPendingTagModifications()) {
                _context3.next = 20;
                break;
              }
              _context3.next = 20;
              return this.updateTagsForEntry();
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function normalSubmit() {
        return _normalSubmit.apply(this, arguments);
      }
      return normalSubmit;
    }()
  }, {
    key: "temporarySubmit",
    value: function () {
      var _temporarySubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var entry, workingEntry, workingBankEntry, createEntryCb, newBankEntry, toClear;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              entry = this.props.entry;
              workingEntry = entry.getWorkingInstance();
              workingBankEntry = this.props.bankEntry.getWorkingInstance();
              createEntryCb = this.isItemEntry() ? createItem : createStimulus;
              _context4.next = 6;
              return this.props.createEntryAndBankEntry(this.props.bankId, workingEntry, workingBankEntry, createEntryCb);
            case 6:
              newBankEntry = _context4.sent;
              if (this.hasPendingTagModifications()) {
                this.props.createTagAssociations(newBankEntry.id, newBankEntry.entry_type, newBankEntry.entry.id, this.props.pendingAdditionTags.map(function (tagToAdd) {
                  return tagToAdd.get('tag_value');
                }));
              }
              toClear = this.isItemEntry() ? 'items' : 'stimuli';
              this.props.clearModifications(toClear, entry.id);
              this.props.clearTemporaryBankItem(this.props.bankId);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function temporarySubmit() {
        return _temporarySubmit.apply(this, arguments);
      }
      return temporarySubmit;
    }()
  }, {
    key: "renderFeedbackSection",
    value: function renderFeedbackSection() {
      if (!this.isItemEntry()) {
        return;
      }
      var shouldClone = this.props.shouldClone;
      var disabled = this.props.entry.isImmutable() && !shouldClone;
      var icon, text;
      if (this.props.entry.getWorkingInstance().hasFeedback()) {
        icon = IconDiscussionSolid;
        text = t('Edit Question Level Feedback (present)');
      } else {
        icon = IconDiscussionLine;
        text = t('Edit Question Level Feedback');
      }
      return jsx(IconButton, {
        onClick: this.openFeedbackModal,
        withBackground: false,
        withBorder: false,
        disabled: disabled,
        ref: this.storeFeedbackButtonRef,
        renderIcon: icon,
        screenReaderLabel: text
      });
    }
  }, {
    key: "getBankEntryId",
    value: function getBankEntryId(bankEntry) {
      // bankEntry.entry can be either 'TEMPORARY_ITEM' or an entire Map
      return bankEntry.entry ? bankEntry.entry.get ? bankEntry.entry.get('id') : bankEntry.entry : null;
    }
  }, {
    key: "visibleTagAssociations",
    value: function visibleTagAssociations() {
      var _this$props2 = this.props,
        pendingAdditionTags = _this$props2.pendingAdditionTags,
        pendingDeletionTags = _this$props2.pendingDeletionTags,
        tagAssociations = _this$props2.tagAssociations;
      var existingValues = keyBy(tagAssociations.toJS(), function (t) {
        return t.tag_value;
      });
      var noDuplicates = pendingAdditionTags.filter(function (t) {
        return isUndefined(existingValues[t.get('tag_value')]);
      });
      return tagAssociations.filter(function (tag) {
        return !pendingDeletionTags.includes(tag);
      }).concat(noDuplicates).toJS();
    }
  }, {
    key: "visibleTags",
    value: function visibleTags() {
      return this.visibleTagAssociations().map(function (a) {
        return {
          id: a.tag_id,
          value: a.tag_value
        };
      });
    }
  }, {
    key: "renderEntry",
    value: function renderEntry(entry) {
      var _this2 = this;
      if (!entry) return;
      var _this$props3 = this.props,
        bankEntry = _this$props3.bankEntry,
        useBankTags = _this$props3.useBankTags;
      var props = this.editProps(entry);
      var propsFunc = this.isItemEntry() ? propsForItemVersioningWrapper : propsForStimulusVersioningWrapper;
      var versioningProps = propsFunc(entry.isImmutable(), this.props.shouldClone, this.props.setShouldClone, this.navigateToBank, true);
      var canEdit = !entry.isImmutable() || this.props.shouldClone;
      var ItemComponent = canEdit ? ItemEdit : ItemShow;
      var StimulusComponent = canEdit ? StimulusEditInfo : StimulusShowInfo;
      var EntryComponent = this.isItemEntry() ? ItemComponent : StimulusComponent;
      var entryType = bankEntry.entryType;
      var entryId = this.getBankEntryId(bankEntry);
      var tags = function tags() {
        return jsx(TagSuggestSelect, {
          allowNewTags: true,
          noMatchText: t('Enter a tag to find or create'),
          parentType: entryType,
          parentId: entryId,
          onChange: _this2.handleTagChange,
          tags: _this2.visibleTags()
        });
      };
      var editWarning = this.isItemEntry() ? t('Edits made here will appear on any assessment using this question.') : t('Edits made here will appear on any assessment using this stimulus.');
      return jsx("div", null, jsx("div", {
        css: this.props.styles.entryEdit
      }, jsx(WarningWrapper, versioningProps, canEdit && jsx(Alert, {
        renderCloseButtonLabel: t('Dismiss'),
        margin: "0 0 medium 0"
      }, jsx(Text, {
        color: "primary"
      }, editWarning)), jsx(EntryComponent, props), useBankTags && tags())), jsx("div", {
        css: this.props.styles.footer
      }, jsx("div", {
        css: this.props.styles.leftFooter
      }, this.renderFeedbackSection()), jsx("div", {
        css: this.props.styles.rightFooter
      }, jsx(EntrySave, props))));
    }
  }, {
    key: "render",
    value: function render() {
      var entry = this.props.entry;
      if (entry && !entry.isLoaded()) {
        return jsx(Spinner, null);
      }
      return jsx(Page, null, this.renderNav(), jsx("div", {
        css: this.props.styles.content,
        ref: this.handleRef
      }, this.props.iceTopNavBarEnabled && jsx("div", {
        css: this.props.styles.breadcrumb
      }, jsx(HeaderBreadCrumb, {
        returnToUrl: this.props.returnToUrl,
        scope: this.props.scope,
        navigateToBanks: this.props.navigateToBanks,
        navigateToBuild: this.props.navigateToBuild
      }, this.renderBankBreadCrumbLink(), this.renderBankEntryBreadCrumbLink())), this.renderHeader(entry), this.renderEntry(entry), !this.props.isCompact && jsx(ItemFeedbackModal, {
        parentId: this.props.bankId,
        parentType: PARENT_TYPE_BANK
      })));
    }
  }]);
}(Component), _defineProperty(_BankEntry, "displayName", 'BankEntry'), _defineProperty(_BankEntry, "componentId", "Quizzes".concat(_BankEntry.displayName)), _defineProperty(_BankEntry, "propTypes", {
  bankEntryId: PropTypes.string.isRequired,
  bankId: PropTypes.string.isRequired,
  bank: ImmutablePropTypes.record.isRequired,
  bankEntry: ImmutablePropTypes.record.isRequired,
  entry: ImmutablePropTypes.record,
  changeItemTitle: PropTypes.func.isRequired,
  changeQuizEntryPoints: PropTypes.func.isRequired,
  cloneBankEntry: PropTypes.func.isRequired,
  clearModifications: PropTypes.func.isRequired,
  clearTemporaryBankItem: PropTypes.func.isRequired,
  createEntryAndBankEntry: PropTypes.func.isRequired,
  closeTray: PropTypes.func,
  createTagAssociations: PropTypes.func.isRequired,
  deleteTagAssociations: PropTypes.func.isRequired,
  getBankEntry: PropTypes.func.isRequired,
  getBank: PropTypes.func.isRequired,
  isCompact: PropTypes.bool,
  navigateToBanks: PropTypes.func.isRequired,
  // can be from consumer
  navigateToBank: PropTypes.func.isRequired,
  // can be from consumer
  navigateToBuild: PropTypes.func,
  // from consumer
  scope: PropTypes.objectOf(PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string,
    launch_context_uuid: PropTypes.string,
    root_account_name: PropTypes.string
  })),
  returnToUrl: PropTypes.string,
  // from consumer
  openModal: PropTypes.func.isRequired,
  pendingAdditionTags: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  pendingDeletionTags: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  setPendingAdditionTagAssociations: PropTypes.func.isRequired,
  setPendingDeletionTagAssociations: PropTypes.func.isRequired,
  setShouldClone: PropTypes.func.isRequired,
  setTagInput: PropTypes.func.isRequired,
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool.isRequired,
  tagAssociations: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  tagInput: PropTypes.string,
  updateItem: PropTypes.func.isRequired,
  updateStimulus: PropTypes.func.isRequired,
  useBankTags: PropTypes.bool,
  iceTopNavBarEnabled: PropTypes.bool,
  styles: PropTypes.object
}), _defineProperty(_BankEntry, "defaultProps", {
  closeTray: function closeTray() {},
  entry: null,
  isCompact: false,
  navigateToBuild: null,
  scope: {},
  returnToUrl: null,
  pendingAdditionTags: Immutable.List(),
  pendingDeletionTags: Immutable.List(),
  tagAssociations: Immutable.List(),
  tagInput: null,
  useBankTags: false,
  iceTopNavBarEnabled: false
}), _BankEntry)) || _class);
export default BankEntry;